/**
 * Store for act-as user ID. Used by read API layer (no React context) when impersonating.
 * Set by ImpersonationContext on start/stop.
 */

let actAsUserId = null;

export function setActAs(userId) {
  actAsUserId = userId;
}

export function getActAsUserId() {
  return actAsUserId;
}

export function clearActAs() {
  actAsUserId = null;
}

/**
 * Effective UID for data fetches: when impersonating, returns act-as user;
 * otherwise returns the real user's uid. Use when fetching "current user" data.
 * @param {object} currentUser - Firebase Auth user (from useAuth)
 * @returns {string|null} effective user id
 */
export function getEffectiveUid(currentUser) {
  const actAs = getActAsUserId();
  if (actAs) return actAs;
  return currentUser?.uid ?? null;
}
